import { useEffect, useState } from "react";
import { dataDecrypt, encrypt } from "../../../../app/utility/encryption-helper";
import { ApisService } from "../../../../app/core/apis.service";
import { useLocation, useParams } from "react-router-dom";
import { FormatIndianDate } from "../../../../app/utility/formatIndianDate";
import { Breadcrumb } from "../../../../components/breadcum";
import { getMonthStartAndEndDates } from "../../../../app/utility/monthStartEndDate";

export const TransactionDetailsView = () => {
    const { startDate, endDate } = getMonthStartAndEndDates();
    const params = useParams();
    const location = useLocation();
    const [loading, setLoading] = useState<boolean>(false);
    const [fromDate, setFromDate] = useState<any>(startDate);
    const [toDate, setToDate] = useState<any>(endDate);
    const [history, setHistory] = useState<any>();
    const [offlineConnection, setOfflineConnection] = useState<boolean>(false);

    useEffect(() => {
        let payload = {
            buId: params.org,
            filters: {
                DateFrom: startDate,
                DateTo: endDate,
                name: params.type,
                offline: null
            },
        };
        loadTransactions(payload);
        setOfflineConnection(location.pathname.includes("offline-connections"))
    }, []);
    async function loadTransactions(payload: any): Promise<void> {
        setLoading(true);
        try {
            let encryptedData = encrypt(JSON.stringify(payload));
            const res = await ApisService.transactionApi("findByTransactionBuId", encryptedData);
            const transactionsData = JSON.parse(dataDecrypt(res.data.data));
            console.log(transactionsData,"transactionsData");
            if(transactionsData === "No data found"){
                 setHistory({results:[]});
            }
            else{
            const response = transactionsData?.results;
            setHistory(response.reverse());
            }
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
        }
    }
    const breadcrumbInfo = [
        {
            label: `${offlineConnection ? "Offline Connections" : "Online Connections"}`,
            value: `${offlineConnection ? "Offline Connections" : "Online Connections"}`,
            routerLink: `${offlineConnection ? `/dashboard/organizations/org-details/${params.page}/${params.org}/offline-connections` : `/dashboard/organizations/org-details/${params.page}/${params.org}/online-connections`}`,
            isActive: false,
        },
        {
            label: params.type,
            value: params.type,
            routerLink: ``,
            isActive: true,
        },
    ];

    const selectFromDate = (e: any) => {
        setFromDate(e.target.value);
    }

    const selectToDate = (e: any) => {
        setToDate(e.target.value)
    }

    const applyFilters = () => {
        let payload = {
            buId: params.org,
            filters: {
                DateFrom: fromDate,
                DateTo: toDate,
                name: params.type,
                offline: null
            },
        };
        loadTransactions(payload);
    };

    const clearFilters = () => {
        setFromDate(startDate);
        setToDate(endDate);
        let payload = {
            buId: params.org,
            filters: {
                DateFrom: startDate,
                DateTo: endDate,
                name: params.type,
                offline: null
            },
        };
        loadTransactions(payload);
    };

    return (
        <div className="container-fluid content-bg-color">
            <Breadcrumb breadCrumbList={breadcrumbInfo}></Breadcrumb>
            <h5 className="fw-bold primary-color mb-2">Transaction History</h5>
            {!loading &&
                <div>
                    <div className="row">
                        <div className="col-md-5 mb-2">
                            <input type="date" className="form-control" value={fromDate} onChange={selectFromDate} />
                        </div>
                        <div className="col-md-5 mb-2">
                            <input type="date" className="form-control" value={toDate} min={fromDate} onChange={selectToDate} />
                        </div>
                        <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={applyFilters}>Search</button></div>
                        <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={clearFilters}>Clear</button></div>
                    </div>
                    {history?.length > 0 ? <> {history?.map((value: any, index: any) => (
                        <div className="card mb-2 box-shadow" key={index}>
                            <div className="card-body py-2 lh-1-5">
                                <div className="row">
                                    <div className="col-md-3 my-2">
                                        <div className="fw-bold">Txn No</div>
                                        {value?._id}
                                    </div>
                                    <div className="col-md-3 my-2">
                                        <div className="fw-bold">Seller Name</div>
                                        {value?.seller?.name}
                                    </div>
                                    <div className="col-md-3 my-2">
                                        <div className="fw-bold">Buyer Name</div>
                                        {value?.buyer?.name}
                                    </div>
                                    <div className="col-md-3 my-2">
                                        <div className="fw-bold">Status</div>
                                        <div className={`${(value?.status === "Discussion started" ? "text-primary" : ((value?.status === "Order Accepted" || value?.status === "Stock resolved" || value?.status === "Discussion Accepted") ? "text-success" : (value?.status === "Discussion not accepted by seller") ? "text-danger" : "text-warning"))}`}>{value?.status}</div>
                                    </div>
                                    <div className="col-md-3 my-2">
                                        <div className="fw-bold">Created Date</div>
                                        {FormatIndianDate(value?.created_date, "")}
                                    </div>
                                    <div className="col-md-3 my-2">
                                        <div className="fw-bold">Customer Type</div>
                                        {value?.transaction_type}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}</> : <div className="text-center">No Data Found</div>}
                </div>}
        </div>
    )
}